// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5279":"6c44d60f","5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"2424":"97f5eebfdedb5a8c","5279":"0dbba0bd62040fc0","5317":"d73ddd515db7d56e","5443":"1edd6e2d15c7bacb","6350":"fa9f39833c1c3ce1","7229":"748284644f480175"}[chunkId] + ".js";
};